import { HStack, Stack, Text } from '@chakra-ui/react';
import React, { FC } from 'react';
import { GoalDto } from '../../../../helpers/goals.types';

interface ShowFieldsProps {
  clickedGoal: GoalDto | null;
}

const ShowFields: FC<ShowFieldsProps> = ({ clickedGoal }) => {
  if (!clickedGoal) return null;

  return (
    <HStack spacing={6}>
      {clickedGoal?.fields?.map((item) => (
        <Stack spacing={0}>
          <Text
            fontSize="sm"
            fontFamily="heading"
            fontWeight="semibold"
            color="text.secondary"
          >
            {item.field}
          </Text>
          {Object.entries(clickedGoal?.fieldsValue)?.map(([key, val]) => (
            <Text
              fontFamily="heading"
              fontSize="sm"
              fontWeight="normal"
              color="text.primary"
            >
              {key === item.key && val}
            </Text>
          ))}
        </Stack>
      ))}
    </HStack>
  );
};

export default ShowFields;
